import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Card } from './card.jsx';
import type { PlaceholderProps } from './types.js';

/** `<Placeholder>` component. */
export const Placeholder = ({ className, icon, ...props }: PlaceholderProps): ReactElement => (
  <Card
    className={twMerge(
      'grid aspect-video content-center justify-center border-secondary text-primary opacity-50 hover:border-secondary hover:opacity-100',
      className
    )}
    {...props}
  >
    {icon}
  </Card>
);
